import http from 'hub-http/clients/apiClient';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import PortalIdParser from 'PortalIdParser';
import { getPropertyValue, setPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { INBOUND_LIST_PROPERTIES, INBOUND_LIST_API } from './constant';
import { getNonCrmPropertyValue } from './utils';
import { AUTOMATED_SMS_STATUS } from 'messaging-publishing-lib/constant/sms';
import { SMS_TYPE } from 'messaging-types-lib/content/contentSms';
import cloneDeep from 'hs-lodash/cloneDeep';
export function fetchSmsDetails(crmObject) {
  const smsId = getPropertyValue(crmObject, 'hs_content_id');
  return cachedHttp.get(`api/messaging-sms/v1/details/${smsId}`);
}
export function fetchSmsLists(listIds) {
  return cachedHttp.post(INBOUND_LIST_API, {
    data: {
      fetchAllProperties: false,
      includePrivate: false,
      properties: INBOUND_LIST_PROPERTIES,
      listFilterProperties: {
        objectTypeId: OBJECT_TYPE.CONTACT,
        listIds
      }
    }
  }).then(response => {
    return response.results.map(list => ({
      objectId: list.objectId,
      objectTypeId: OBJECT_TYPE.OBJECT_LIST,
      portalId: PortalIdParser.get(),
      properties: {
        hs_list_name: {
          value: list.properties.hs_list_name && list.properties.hs_list_name.value
        },
        hs_list_id: {
          value: list.properties.hs_list_id && list.properties.hs_list_id.value
        },
        hs_classic_list_id: {
          value: list.properties.hs_classic_list_id && list.properties.hs_classic_list_id.value
        },
        hs_object_type_id: {
          value: list.properties.hs_object_type_id && list.properties.hs_object_type_id.value
        }
      }
    }));
  }).catch(() => []);
}
// example: https://tools.hubteamqa.com/api/request/ee17012afb3a4ed9b4fa242f34a58cd9
export function fetchSmsAssociatedListsAsCrmObjects({
  nonCrmObject,
  isIncluded
}) {
  const smsType = getNonCrmPropertyValue('smsType', nonCrmObject);
  const isAutomatedSms = smsType === AUTOMATED_SMS_STATUS.AUTOMATED;
  if (isAutomatedSms) {
    return [];
  }
  const smsMicSendConfig = getNonCrmPropertyValue('micSendConfigs', nonCrmObject);
  const smsRootConfig = smsMicSendConfig.filter(c => c.isRoot);
  const inclusionListIds = smsRootConfig && smsRootConfig.length && smsRootConfig[0].metadata && smsRootConfig[0].metadata.inclusionLists || [];
  const exclusionListIds = smsRootConfig && smsRootConfig.length && smsRootConfig[0].metadata && smsRootConfig[0].metadata.exclusionLists || [];
  const listIds = isIncluded ? inclusionListIds : exclusionListIds;
  if (!listIds || listIds.length === 0) {
    return [];
  }
  return fetchSmsLists(listIds);
}
export function fetchSmsPerformance(rootMicId) {
  return cachedHttp.post(`api/short-messages-insights/v1/sms/performance/overview`, {
    data: {
      rootMicId
    }
  });
}
export function fetchSmsWorkflowAssociationGroup(crmObject) {
  const smsId = getPropertyValue(crmObject, 'hs_content_id');
  const smsType = getPropertyValue(crmObject, 'hs_sms_type');
  if (smsType !== SMS_TYPE.AUTOMATED) {
    return Promise.resolve({
      '@ok': [],
      '@result': 'OK'
    });
  }
  return cachedHttp.get(`api/messaging-sms/v1/workflows/action/usages/sms/${smsId}`);
}
export async function updateSMS({
  crmObject,
  changes
}) {
  const hsContentId = getPropertyValue(crmObject, 'hs_content_id', '');

  /**
   * Create a copy of the existing crm object applying new values coming from @changes
   * This API doesnt return a CRM object as a response so we have to manually return
   * the updated CRM object
   */
  let updatedCRMObject = cloneDeep(crmObject);
  const payload = {};
  Object.keys(changes).forEach(propertyName => {
    updatedCRMObject = setPropertyValue(updatedCRMObject, propertyName, changes[propertyName]);
    if (propertyName === 'hs_name') {
      payload['name'] = changes[propertyName];
    } else {
      if (!payload.customProperties) {
        payload.customProperties = {
          propertyValues: []
        };
      }
      payload.customProperties.propertyValues.push({
        name: propertyName,
        value: changes[propertyName]
      });
    }
  });
  await http.put(`messaging-sms/v1/sms/${hsContentId}`, {
    data: payload
  });
  return updatedCRMObject;
}